import { render, staticRenderFns } from "./KitsilanoHeldOrders.vue?vue&type=template&id=0879ca1c"
import script from "./KitsilanoHeldOrders.vue?vue&type=script&lang=js"
export * from "./KitsilanoHeldOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports